export enum AgencyRole {
  AgencyUser = "agency-user",
  AgencyOwner = "agency-owner",
  AgencyTeamLeader = "agency-team-leader",
  AgencyClientUser = "agency-client-user",
  AgencyAdmin = "agency-admin",
}
